export default __webpack_public_path__ + "static/kynnet3-d0a1af9a3bfe71047ea7e1508b9d4bd2.jpeg";